module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2x"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "id": "eth"
    }
  }), _vm._v("ETHNOMUSICOLOGY MULTIMEDIA SERIES PREFACE")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Each of the audio, video, or still image media examples listed below is associated with specific passages in this book, and each example has been assigned a unique Persistent Uniform Resource Locator, or PURL. The PURL identifies a specific audio, video, or still image media example on the Ethnomusicology Multimedia website, "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://www.ethnomultimedia.org",
      "target": "_blank"
    }
  }, [_vm._v("www.ethnomultimedia.org")])]), _vm._v(". Within the text of the book, a PURL number in parentheses functions like a citation and immediately follows the text to which it refers (e.g., "), _c('a', {
    attrs: {
      "id": "rpurl3.1"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/preface#purl3.1"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("PURL 3.1")])]), _vm._v(" refers to the first media example found in "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 3")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To access all media associated with this book, readers must first create a free account by going to "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://www.ethnomultimedia.org",
      "target": "_blank"
    }
  }, [_vm._v("www.ethnomultimedia.org")])]), _vm._v(" and clicking the “Sign up for free” link. Site visitors are also required to read and electronically sign an End Users License Agreement ("), _c('span', {
    staticClass: "small"
  }, [_vm._v("EULA")]), _vm._v("). Afterward, there are two ways to access audio, video, and still image media examples. In the search field, one may enter the name of the author to access a webpage with information about the book and author as well as a playlist of all media examples associated with the book. Or, to access a specific media example, the six-digit PURL identifier (the six digits located at the end of the full PURL address below) may be entered into the search field. The reader will then be taken to the web page containing that media example as well as a playlist of all the other media examples related to the book. Readers of the electronic edition of this book may simply click on the PURL address for each media example; once they have logged in to the Ethnomusicology Multimedia website, the live link will take them directly to the media example.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3x"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _vm._v("LIST OF PURLS")]), _vm._v(" "), _c('h4', {
    staticClass: "h4x"
  }, [_vm._v("CHAPTER 1")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('a', {
    attrs: {
      "id": "purl1.1"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter1#rpurl1.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PURL 1.1")]), _vm._v(". “Verklärte Kristallnacht.” Gary Lucas, guitar. Berlin Jazz Festival, November 1988. Audio.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Barzel/910284",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Barzel/910284")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('a', {
    attrs: {
      "id": "purl1.2"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter1#rpurl1.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PURL 1.2")]), _vm._v(". "), _c('em', [_vm._v("The Golem")]), _vm._v(" (1920, dir. Paul Wegener and Carl Boese), with original solo guitar soundtrack; music by Gary Lucas and Walter Horn (10 min. excerpt). Video.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Barzel/910279",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Barzel/910279")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('a', {
    attrs: {
      "id": "purl1.3"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter1#rpurl1.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PURL 1.3")]), _vm._v(". Shelley Hirsch, “I Am a Jew” (1980). Shelley Hirsch, solo vocal and taped overdubs. On "), _c('em', [_vm._v("States")]), _vm._v(" (Tellus, 1997). Audio.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Barzel/910285",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Barzel/910285")])])]), _vm._v(" "), _c('h4', {
    staticClass: "h4z"
  }, [_vm._v("CHAPTER 2")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('a', {
    attrs: {
      "id": "purl2.1"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter2#rpurl2.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PURL 2.1")]), _vm._v(". Shrek, “Yo! I Killed Your God,” early 1990s performance at the Knitting Factory. Marc Ribot (guitar and vocals), with Christine Bard (drums), Jim Pugliese (drums), Sebastian Steinberg (bass), and Chris Wood (guitar). On "), _c('em', [_vm._v("Marc Ribot: Descent into Baldness")]), _vm._v(", directed and produced by Cassis Birgit Staudt and Joerg Soechting. © Cassis Birgit Staudt and Joerg Soechting. "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://www-marcribot-descentintobaldness.com",
      "target": "_blank"
    }
  }, [_vm._v("http://www-marcribot-descentintobaldness.com")])]), _vm._v(". Video.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Barzel/910280",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Barzel/910280")])])]), _vm._v(" "), _c('h4', {
    staticClass: "h4z"
  }, [_vm._v("CHAPTER 3")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('a', {
    attrs: {
      "id": "purl3.1"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#rpurl3.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PURL 3.1")]), _vm._v(". Alvin Curran, "), _c('em', [_vm._v("Crystal Psalms")]), _vm._v(" (New Albion Records, 1994). Excerpt. Audio.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Barzel/910286",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Barzel/910286")])])]), _vm._v(" "), _c('h4', {
    staticClass: "h4z"
  }, [_vm._v("CHAPTER 4")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('a', {
    attrs: {
      "id": "purl4.1"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#rpurl4.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PURL 4.1")]), _vm._v(". G - d Is My Co-Pilot, “Mi Yimalel” on "), _c('em', [_vm._v("Mir Shlufn Nisht")]), _vm._v(" (1994). Sharon Topper, vocals; Craig Flanagin, guitar; Fred Lonberg-Holm, cello; Alex Klein, bass; Michael Evans, drums; Siobhan Duffy, drums. Arranged and produced by Craig Flanagin. Audio.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Barzel/910287",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Barzel/910287")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('a', {
    attrs: {
      "id": "purl4.2"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#rpurl4.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PURL 4.2")]), _vm._v(". G - d Is My Co-Pilot, “Ha-Tikvah,” on "), _c('em', [_vm._v("Mir Shlufn Nisht")]), _vm._v(" (Disk Union, 1994). Audio.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Barzel/910288",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Barzel/910288")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('a', {
    attrs: {
      "id": "purl4.3"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#rpurl4.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PURL 4.3")]), _vm._v(". Zadikov Workers Choir, “Hay Naalayim” (Joel Engel and Avigdor Hameiri), on "), _c('em', [_vm._v("Hayo Hayu Zmanim: Israeli Tunes of Yesteryear 1")]), _vm._v(" (Hed-Artzi, 1960). "), _c('em', [_vm._v("Collection of the Dartmouth Jewish Sound Archive")]), _vm._v(". Audio.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Barzel/910289",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Barzel/910289")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('a', {
    attrs: {
      "id": "purl4.4"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#rpurl4.4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PURL 4.4")]), _vm._v(". G - d Is My Co-Pilot, “B’Nai!” on "), _c('em', [_vm._v("Mir Shlufn Nisht")]), _vm._v(" (1994).")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Barzel/910290",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Barzel/910290")])])]), _vm._v(" "), _c('h4', {
    staticClass: "h4z"
  }, [_vm._v("CHAPTER 5")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('a', {
    attrs: {
      "id": "purl5.1"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#rpurl5.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PURL 5.1")]), _vm._v(". Shelley Hirsch, "), _c('em', [_vm._v("States")]), _vm._v(", on Roulette "), _c('span', {
    staticClass: "small"
  }, [_vm._v("TV")]), _vm._v(" (2001). Shelley Hirsch, solo vocal, with taped overdubs. Excerpt. Produced and directed by Jim Staley. Video.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Barzel/910281",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Barzel/910281")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('a', {
    attrs: {
      "id": "purl5.2"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#rpurl5.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PURL 5.2")]), _vm._v(". “Hymie and Harry” (0'00\" to 0'36\"). Radio version of "), _c('em', [_vm._v("O Little Town of East New York")]), _vm._v(" (1992), commissioned by New American Radio. Text by Shelley Hirsch; music by Shelley Hirsch and David Weinstein. Shelley Hirsch. "), _c('em', [_vm._v("New American Radio and Performing Arts online archive")]), _vm._v(". Audio.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Barzel/910291",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Barzel/910291")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('a', {
    attrs: {
      "id": "purl5.3"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#rpurl5.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PURL 5.3")]), _vm._v(". “Confession Booth” (6'39\" to 7'28\"). Radio version of "), _c('em', [_vm._v("O Little Town of East New York")]), _vm._v(" (1992).")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Barzel/910292",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Barzel/910292")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('a', {
    attrs: {
      "id": "purl5.4"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#rpurl5.4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PURL 5.4")]), _vm._v(". “544 Hemlock Street” (2'14\" to 4'33\"). On "), _c('em', [_vm._v("O Little Town of East New York")]), _vm._v(" (1991), filmed on location at the Dance Theater Workshop. Text by Shelley Hirsch; music by Shelley Hirsch and David Weinstein; film and slides, Shelley Hirsch and Eric Muzzy; camera, Eric Muzzy; decor, Shelley Hirsch, Gail O’Keefe, Liz Prince; costumes, Liz Prince; lighting, Lori Dawson; audio, Brooks Williams and David Weinstein. Video.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Barzel/910282",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Barzel/910282")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('a', {
    attrs: {
      "id": "purl5.5"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#rpurl5.5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PURL 5.5")]), _vm._v(". “Maria’s House/The Troika” (4'47\" to 6'35\"). Radio version of "), _c('em', [_vm._v("O Little Town of East New York")]), _vm._v(" (1992). Audio.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Barzel/910293",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Barzel/910293")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('a', {
    attrs: {
      "id": "purl5.6"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#rpurl5.6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PURL 5.6")]), _vm._v(". “On the Far Reaches” (22'33\" to the end). Radio version of "), _c('em', [_vm._v("O Little Town of East New York")]), _vm._v(" (1992). Audio.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Barzel/910294",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Barzel/910294")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('a', {
    attrs: {
      "id": "purl5.7"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#rpurl5.7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PURL 5.7")]), _vm._v(". “The Jewish People” (7'29\" to 8'26\"). Radio version of "), _c('em', [_vm._v("O Little Town of East New York")]), _vm._v(" (1992). Audio.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Barzel/910295",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Barzel/910295")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('a', {
    attrs: {
      "id": "purl5.8"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#rpurl5.8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PURL 5.8")]), _vm._v(". “The Jewish People” (20'56\" to 21'58\"). On "), _c('em', [_vm._v("O Little Town of East New York")]), _vm._v(" (1991). Video.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Barzel/910283",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Barzel/910283")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('a', {
    attrs: {
      "id": "purl5.9"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#rpurl5.9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PURL 5.9")]), _vm._v(". Anthony Coleman, “Jevrejski by night.” Live performance at Issue Project Room, Brooklyn (2005). Anthony Coleman, piano; Michaël Attias, saxophone, Marco Cappelli, guitar; Greg Cohen, contrabass; Fred Lonberg-Holm, cello; Jim Pugliese, percussion; Ted Reichman, accordion, Michael Sarin, percussion, Douglas Wieselman, clarinet, bass clarinet, guitar. Audio.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Barzel/910296",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Barzel/910296")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('a', {
    attrs: {
      "id": "purl5.10"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#rpurl5.10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PURL 5.10")]), _vm._v(". Ben Goldberg Trio, “Speech Communication: Anglais.” Museum of Jewish Art and History, Paris, June 2010 (94 mins.). Ben Goldberg, clarinet; Greg Cohen, bass; Kenny Wolleson, drums.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('img', {
    staticClass: "block",
    attrs: {
      "alt": "image",
      "src": "images/f000x-01.jpg"
    }
  }), _vm._v(" Broadcast by "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://Akadem.org",
      "target": "_blank"
    }
  }, [_vm._v("Akadem.org")])]), _vm._v(". Video.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Barzel/910276",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Barzel/910276")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('a', {
    attrs: {
      "id": "purl5.11"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#rpurl5.11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PURL 5.11")]), _vm._v(". Anthony Coleman, “8 Objectives: The Abysmal Richness of the Infinite Proximity of the Same.” Live performance at Issue Project Room, Brooklyn (2005). Anthony Coleman, piano; Michaël Attias, saxophone, Marco Cappelli, guitar; Greg Cohen, contrabass; Fred Lonberg-Holm, cello; Jim Pugliese, percussion; Ted Reichman, accordion, Michael Sarin, percussion, Douglas Wieselman, clarinet, bass clarinet, guitar. Audio.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Barzel/910297",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Barzel/910297")])])]), _vm._v(" "), _c('h4', {
    staticClass: "h4z"
  }, [_vm._v("EPILOGUE")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('a', {
    attrs: {
      "id": "purle.1"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/epilogue#rpurle.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PURL E.1")]), _vm._v(". “La Radical Jewish Culture,” Paris Museum of Jewish Art and History, April 2010 (141 mins.). Tamar Barzel with Anthony Coleman, Mathias Dreyfuss, and Nico Schneider, translation.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('img', {
    staticClass: "block",
    attrs: {
      "alt": "image",
      "src": "images/f000x-01.jpg"
    }
  }), _vm._v(" Broadcast by "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://Akadem.org",
      "target": "_blank"
    }
  }, [_vm._v("Akadem.org")])]), _vm._v(". Video.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Barzel/910277",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Barzel/910277")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _c('a', {
    attrs: {
      "id": "purle.2"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/epilogue#rpurle.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PURL E.2")]), _vm._v(". “Ecouter le flâneur flâner,” Paris Museum of Jewish Art and History, April 2010 (13 mins.). Anthony Coleman, spoken introduction, piano and pre-recorded electronics, Ashley Paul, saxophone.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('img', {
    staticClass: "block",
    attrs: {
      "alt": "image",
      "src": "images/f000x-01.jpg"
    }
  }), _vm._v(" Broadcast by "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://Akadem.org",
      "target": "_blank"
    }
  }, [_vm._v("Akadem.org")])]), _vm._v(". Video.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Barzel/910278",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Barzel/910278")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11292466","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/preface.vue
// module id = 75
// module chunks = 0